<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card elevation="0" class="pa-3" max-width="1000px">
      <div class="d-flex align-center">
        <div
          class="md-body-no-spacing pl-4"
          v-if="stockInfo && stockInfo.length == 1"
        >
          {{ productName }}
        </div>
        <v-spacer />
        <v-btn @click="close" icon variant="plain"><v-icon icon="close" /></v-btn>
      </div>
      <div class="md-subheader-no-spacing pl-4 mb-3">Stock Availability</div>
      <div v-if="error">error</div>
      <div v-else>
        <v-col style="overflow: auto">
          <v-table>
            <thead>
              <tr id="table-header">
                <th
                  v-if="stockInfo && stockInfo.length > 1"
                  class="table-y-axis-text color-cell"
                  :style="'width: 200px'"
                >
                  <div
                    class="d-flex justify-start ellipsis-overflow"
                    >Name</div>
                </th>
                <th
                  class="table-y-axis-text color-cell"
                  :style="
                    stockInfo && stockInfo.length > 1 ? 'width: 200px' : ''
                  "
                >
                  <div
                    class="d-flex justify-start ellipsis-overflow"
                    >Color</div>
                </th>
                <th
                  v-for="(header, index) in headers"
                  :key="`${header.text}_${index}`"
                  :style="
                    header.type == 'ordered_stock'
                      ? 'border-right: thin solid lightgrey'
                      : stockInfo && stockInfo.length > 1 && index == 0
                      ? 'padding-left: 250px'
                      : index == 0
                      ? 'padding-left: 150px'
                      : ''
                  "
                >
                  <div class="d-flex flex-column justify-start">
                    {{ header.text }}
                    <div v-if="header.type == 'stock'">In Stock</div>
                    <div v-else>Ordered</div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingTable">
                <td :colspan="headers.length + (stockInfo && stockInfo.length > 1 ? 2 : 1)" class="text-center py-4">
                  <v-progress-circular indeterminate size="24" width="2" />
                </td>
              </tr>
              <tr v-else-if="tableItems.length === 0" class="no-data-text">
                <td :colspan="headers.length + (stockInfo && stockInfo.length > 1 ? 2 : 1)">
                  <p class="pt-3 font-weight-regular text-grey-darken-1">
                    No Stock Info Available
                  </p>
                </td>
              </tr>
              <template v-else>
              <tr v-for="(item, itemIdx) in tableItems" :key="itemIdx">
                <td
                  v-if="stockInfo && stockInfo.length > 1"
                  class="table-y-axis-text color-cell"
                  :style="'width: 200px'"
                >
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <div class="ellipsis-overflow" v-bind="props">
                        {{ item.product_name }}
                      </div>
                    </template>
                    <span>
                      {{ item.product_name }}
                    </span>
                  </v-tooltip>
                </td>
                <td
                  class="table-y-axis-text color-cell"
                  :style="
                    stockInfo && stockInfo.length > 1 ? 'width: 200px' : ''
                  "
                >
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <div class="ellipsis-overflow" v-bind="props">
                        {{ item.color }}
                      </div>
                    </template>
                    <span>
                      {{ item.color }}
                    </span>
                  </v-tooltip>
                </td>
                <td
                  v-for="(header, index) in headers"
                  :key="`${header.value}_${index}`"
                  :style="
                    header.type == 'ordered_stock'
                      ? 'border-right: thin solid lightgrey'
                      : stockInfo && stockInfo.length > 1 && index == 0
                      ? 'padding-left: 250px'
                      : index == 0
                      ? 'padding-left: 150px'
                      : ''
                  "
                >
                  <div class="d-flex justify-center">
                    <div
                      v-if="
                        item[header.type][header.value] ||
                          item[header.type][header.value] == 0 ||
                          item[`low_stock_alert`][header.value]
                      "
                      :style="
                        item[`low_stock_alert`][header.value]
                          ? 'color: red'
                          : ''
                      "
                    >
                      {{ item[header.type][header.value] }}
                    </div>
                    <div
                      v-else-if="header.type == 'stock'"
                      style="color: lightgrey"
                    >
                      N/A
                    </div>
                    <div v-else style="color: lightgrey">0</div>
                  </div>
                </td>
              </tr>
              </template>
            </tbody>
          </v-table>
        </v-col>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
export default {
  props: {
    error: String,
    stockInfo: Array,
    productName: String,
  },
  computed: {},

  data() {
    return {
      showDialog: false,
      loadingTable: false,
      headers: [],
      tableItems: [],
      tableKey: 0,
      orderedSecondaryAttributes: null,
      sizes: [],
    };
  },
  mounted() {},
  methods: {
    sortByPosition(a, b) {
      let comparison = 0;
      if (
        !this.orderedSecondaryAttributes[a.value] ||
        !this.orderedSecondaryAttributes[b.value]
      ) {
        return comparison;
      }
      if (
        this.orderedSecondaryAttributes[a.value] == 0 ||
        this.orderedSecondaryAttributes[a.value] >
          this.orderedSecondaryAttributes[b.value]
      ) {
        comparison = 1;
      } else if (
        this.orderedSecondaryAttributes[b.value] == 0 ||
        this.orderedSecondaryAttributes[a.value] <
          this.orderedSecondaryAttributes[b.value]
      ) {
        comparison = -1;
      }
      return comparison;
    },

    sortHeaders(headers) {
      let sortedHeaders =
        Object.values(headers)
          .sort(this.sortByPosition)
          .map((obj) => obj) || [];
      return sortedHeaders;
    },

    async getOrderedSecondaryAttributes() {
      let result;
      try {
        result = await this.$axios.get(
          "/campaign_product/getOrderedSecondaryAttributes"
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        this.orderedSecondaryAttributes = result.data;
      }
    },

    buildHeaders(color) {
      for (const size in color.stock) {
        if (Object.hasOwnProperty.call(color.stock, size)) {
          const stock = color.stock[size];
          if (!this.sizes.includes(size)) {
            this.headers.push({
              text: size,
              type: "stock",
              value: size,
            });
            this.headers.push({
              text: size,
              type: "ordered_stock",
              value: size,
            });
            this.sizes.push(size);
          }
        }
      }
    },

    async buildTable() {
      this.loadingTable = true;

      await this.getOrderedSecondaryAttributes();
      this.headers = [];
      this.stockInfo.forEach((product) => {
        product.forEach((color) => {
          this.buildHeaders(color);
          this.tableItems.push(JSON.parse(JSON.stringify(color)));
        });
      });
      this.headers = this.sortHeaders(this.headers);

      this.loadingTable = false;
    },

    show() {
      this.showDialog = true;
      this.buildTable();
    },

    close() {
      this.showDialog = false;
      this.headers = [];
      this.tableItems = [];
      this.sizes = [];
    },
  },
};
</script>
<style scoped>
.close-dialog {
  position: absolute;
  top: 10px;
  right: 10px;
}

.table-y-axis-text {
  border-bottom: none;
  position: fixed;
  height: 62px !important;
  padding-top: 14px !important;
  font-size: 16px !important;
  color: black !important;
  font-style: normal !important;
  background-color: var(--tf-surface-muted);
}

.ellipsis-overflow {
  width: 55px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 2px !important;
}

.ellipsis-overflow:hover {
  background: #e7e7e7;
  border-radius: 5px;
}

.color-cell {
  height: 75px !important;
  border-radius: 5px 5px 0px 0px;
}

.last-color-cell {
  border-radius: 0px 0px 5px 5px;
}

::-webkit-scrollbar {
  width: 16px;
}

/* Track */
::-webkit-scrollbar-track {
  background: whitesmoke;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #cfcfcf;
  border-radius: 20px;
  border: 4px solid whitesmoke;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: darkgrey;
}
</style>
